import { render, staticRenderFns } from "./AppComponent.vue?vue&type=template&id=fd8e3f8e"
import script from "./AppComponent.vue?vue&type=script&lang=js"
export * from "./AppComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports